module.exports = __webpack_public_path__ + "media/index_ukulele.9345ff62.mp4";